import App from 'App';
import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from 'serviceWorker';

/* Renderiza o componente principal da aplicação na div root */
ReactDOM.render(<App />, document.getElementById('root'));

/* Desativa o service worker (aplicação não é servida como PWA) */
serviceWorker.unregister();